/**
 * Shift-type labels en kleuren — shared tussen UrenPage en StaffDetailView.
 * De waarde in de `schedule` tabel is lowercase ('wasserij' | 'route' | 'kantoor').
 * De UI toont labels met hoofdletter ('Wasserij' | 'Chauffeur' | 'Kantoor').
 */

export type ShiftTypeValue = 'wasserij' | 'route' | 'kantoor';

export const SHIFT_TYPE_VALUES: ShiftTypeValue[] = ['wasserij', 'route', 'kantoor'];

export const SHIFT_LABELS: Record<ShiftTypeValue, string> = {
  wasserij: 'Wasserij',
  route: 'Chauffeur',
  kantoor: 'Kantoor',
};

export const SHIFT_COLORS: Record<ShiftTypeValue, string> = {
  wasserij: 'bg-blue-100 text-blue-700',
  route: 'bg-emerald-100 text-emerald-700',
  kantoor: 'bg-purple-100 text-purple-700',
};

export function shiftLabel(type: ShiftTypeValue | null | undefined): string {
  if (!type) return '';
  return SHIFT_LABELS[type] ?? '';
}

export function shiftColor(type: ShiftTypeValue | null | undefined): string {
  if (!type) return 'bg-gray-100 text-gray-600';
  return SHIFT_COLORS[type] ?? 'bg-gray-100 text-gray-600';
}
